import React, { useEffect } from 'react'
import { Provider } from 'react-redux'
import { useUserDetails } from 'utils/hooks/useUserDetails'
import { useMPAnalytics } from './hooks'
import { App } from './pages/App'
import { configureStore } from './store/configureStore'

const store = configureStore()

const Marketplace = () => {
  const { userDetails } = useUserDetails()
  const { identifyUser } = useMPAnalytics()

  useEffect(() => {
    identifyUser(userDetails)
  }, [identifyUser, userDetails])

  return (
    <Provider store={store}>
      <App />
    </Provider>
  )
}

export default Marketplace
